"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SequenceKind = exports.ChunkKind = void 0;
var ChunkKind;
(function (ChunkKind) {
    ChunkKind[ChunkKind["Error"] = -1] = "Error";
    ChunkKind[ChunkKind["Initial"] = 0] = "Initial";
    ChunkKind[ChunkKind["EndOfInitial"] = 1] = "EndOfInitial";
    ChunkKind[ChunkKind["Insert"] = 2] = "Insert";
    ChunkKind[ChunkKind["Delete"] = 3] = "Delete";
    ChunkKind[ChunkKind["Expunge"] = 4] = "Expunge";
    ChunkKind[ChunkKind["Update"] = 5] = "Update";
    ChunkKind[ChunkKind["Replace"] = 6] = "Replace";
    ChunkKind[ChunkKind["Order"] = 7] = "Order";
    ChunkKind[ChunkKind["Response"] = 8] = "Response";
})(ChunkKind = exports.ChunkKind || (exports.ChunkKind = {}));
var SequenceKind;
(function (SequenceKind) {
    SequenceKind[SequenceKind["Delete"] = 0] = "Delete";
    SequenceKind[SequenceKind["Substitute"] = 1] = "Substitute";
    SequenceKind[SequenceKind["Insert"] = 2] = "Insert";
})(SequenceKind = exports.SequenceKind || (exports.SequenceKind = {}));
//# sourceMappingURL=index.js.map